const RightIcon = () => {
  return (
    <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.6 6.00024L0 1.40024L1.4 0.000244141L7.4 6.00024L1.4 12.0002L0 10.6002L4.6 6.00024Z"
        fill="#6E6E6E"
      />
    </svg>
  );
};

export default RightIcon;
